/**
 * Known author registry.
 *
 * When a blog_posts record's `author` field matches a `name` in this list,
 * the byline and Article JSON-LD emit Person schema (with `url`) instead of
 * the default Organization schema.
 *
 * Rules:
 * - Do NOT list credentials that aren't verifiable and true.
 * - Any credentialed reviewer must appear via a separate `reviewed_by` field
 *   on the article record — never bundled into an author entry.
 * - See /editorial-policy for editorial standards.
 */
export const AUTHORS = {
  "Aaron Bankhurst": {
    slug: "aaron-bankhurst",
    name: "Aaron Bankhurst",
    role: "Founder & Editor",
    // Bio text approved verbatim by product owner. Do not add credentials.
    bio: "Aaron Bankhurst is the founder and editor of Ohio Accident Aid, where he oversees research, content development, and editorial standards for Ohio accident and injury resources.",
    profileUrl: "https://ohioaccidentaid.com/authors/aaron-bankhurst",
  },
};

export function getAuthor(name) {
  return AUTHORS[name] || null;
}
